module.exports = __webpack_public_path__ + "static/img/downloadbg.bae36b8b.jpg";